export default "__VITE_ASSET__DFEZazov__"